import { render, staticRenderFns } from "./buttons-upload.vue?vue&type=template&id=67bb2a6b"
import script from "./buttons-upload.vue?vue&type=script&lang=ts"
export * from "./buttons-upload.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports